import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import supervisor_Store from "../../store/supervisor_store";
import attend_Store from "../../store/attend_store";
import Attend_Message_Modal from "../../component/Attend_Message_Modal";
import YesNoAsk_Modal from "../../component/YesNoAsk_Modal";
import guideline_Store from "../../store/guideline_store";
import transcript_Store from "../../store/transcript_store";
import { toast } from "react-toastify";
import TableMaker from "../../component/TableMaker";
import { Loading } from "../../component/Loading";
import Transcript_Modal from "../../component/Transcript_Modal";
import { Link } from "react-router-dom";
import HowAttend from "../attend/HowAttend_component";

const suffix = process.env.REACT_APP_SUFFIX_ROUTE;

function AttendShow_Page() {
  const supervisor = supervisor_Store((state) => state.supervisor);
  const editStandardAttend = attend_Store((state) => state.editStandardAttend);

  // Attend Store
  const attendsBaseOnStudent = attend_Store(
    (state) => state.attendsBaseOnStudent
  );
  const location = useLocation();
  const [isAdd, setIsAdd] = useState(false);
  const [isTranscript, setIsTranscript] = useState(false);
  let [officeChecked, setOfficeChecked] = useState("");
  const [newNote, setNewNote] = useState(false);
  let [isSubmitLoading, setIsSubmitLoading] = useState(false);

  // all attend
  const getAttendsBaseOnStudent = attend_Store(
    (state) => state.getAttendsBaseOnStudent
  );
  const guidelines = guideline_Store((state) => state.guidelines);
  const getTranscriptsBaseOnStudent = transcript_Store(
    (state) => state.getTranscriptsBaseOnStudent
  );
  const transcriptsBaseOnStudent = transcript_Store(
    (state) => state.transcriptsBaseOnStudent
  );
  const getGuidelines = guideline_Store((state) => state.getGuidelines);
  const student = location?.state?.student;
  const studentId = student?.id ?? "-1";
  const student_code = student?.code ?? "-1";
  const student_name = student?.name ?? "-1";

  let [reload, setReload] = useState(1);

  const token = supervisor?.token ?? "-1";
  useEffect(() => {
    getGuidelines();
    getAttendsBaseOnStudent(studentId);
    getTranscriptsBaseOnStudent(student_code);
  }, [reload]);

  //#region variables
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [date, setDate] = useState(new Date());

  if ((attendsBaseOnStudent?.data?.length ?? 0) == 0) {
    return <Loading />;
  }
  if ((guidelines?.data?.length ?? 0) == 0) {
    return <Loading />;
  }
  const statusRequest = attendsBaseOnStudent?.data?.[0]?.statusRequest ?? "";
  const note = attendsBaseOnStudent?.data?.[0]?.note ?? "";
  const tablehtmlJson = attendsBaseOnStudent?.data?.[0]?.attendtable?.tableJson;

  async function approveRequest() {
    if (!officeChecked) {
      await toast.error("You forgot to select met with advisee");
    } else {
      const payload = {
        note: "",
        date: date,
        howAttend: officeChecked,
        statusRequest: "Approved",
        submitCounter: "2",
      };

      try {
        setIsSubmitLoading(true)
        const result = await editStandardAttend(payload, studentId);
        if (result?.status == 200) {
          toast.success(`${"Form"} succeeded`);
        } else {
          toast.error(`Form failed`);
        }
        setIsSubmitLoading(false)
        setShow(false);
      } catch (error) {
        setIsSubmitLoading(false)
        const errmsg = error.response?.data?.message;
        if (!errmsg) return;

        // show error reason as an error toast
        if (Array.isArray(errmsg)) {
          errmsg.forEach((element, index) => {
            setTimeout(function () {
              toast.error(element);
            }, 200 * index);
          });
        } else {
          toast.error(errmsg);
        }
      }
    }
  }

  const execFunc = async () => {
    let result;
    try {
      if (newNote == "") {
        toast.error("Failed, Input box should not be empty!");
        return;
      }
      const payload = {
        note: newNote,
        statusRequest: "Rejected",
        date: date,
        isSupervisorTurn: false,
      };
        setIsSubmitLoading(true)
        result = await editStandardAttend(payload, studentId);

      if (result?.status == 200 || result?.status == 201) {
        let msg = "The request rejected successfully";
        toast.success(msg);
        // disappear modal
        setIsAdd(false);
      }
      setIsSubmitLoading(false)
    } catch (error) {
        setIsSubmitLoading(false)
        const errmsg = error.response?.data?.message;
      if (!errmsg) return;

      // show error reason as an error toast
      if (Array.isArray(errmsg)) {
        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element);
          }, 200 * index);
        });
      } else {
        toast.error(errmsg);
      }
    }
    setReload((e) => e + 1);
  };
  const bodyMessage =
    "Dear advisee, I here by confirm your advising form.";

  const bgcolor =
    statusRequest == "pending"
      ? "warning"
      : statusRequest == "Approved"
      ? "success"
      : "danger";

  return (
    <>
      <TableMaker isHidden={false} json={JSON.parse(tablehtmlJson)} />
      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <HowAttend
            officeChecked={officeChecked}
            setOfficeChecked={setOfficeChecked}
          />
          <button
            onClick={() => {
              setIsAdd(true);
            }}
            className="btn text-white bg-danger btn-md"
            type="button"
          >
            <i className="fas fa-ban"></i>
            <span className="ps-1">Reject</span>
          </button>
          <button
            onClick={() => {
              setShow(true);
            }}
            className="btn  btn-outline-success btn-md  ms-4"
            type="button"
          >
            <i className="fas fa-check"></i>Approve
            {/* <i className="bi bi-pencil"></i>Accept */}
          </button>
        </div>
        <div className="p-2 bd-highlight">
          <Link
            to={{ pathname: `${suffix}/attends/student/transcript` }}
            state={{
              student: student,
              data: transcriptsBaseOnStudent ?? [],
            }}
            className="btn  btn-outline-primary btn-md  ms-4"
            type="button"
          >
            <i className="fas fa-scroll"></i> &nbsp; Show Transcript
          </Link>
        </div>
      </div>

      <br />
      <div className="d-flex flex-row bd-highlight mt-4 mb-3">
        <h6>Status: </h6>
        &nbsp;
        <h6 className={`text-${bgcolor}`}>{statusRequest}</h6>
      </div>
      {statusRequest === "Rejected" && (
        <div className="d-flex flex-row bd-highlight mb-3">
          <h6 className="pt-1">Note: </h6> <h6 className="text-danger"></h6>
          &nbsp; &nbsp;
          <div
            className={`text-${bgcolor}`}
            dangerouslySetInnerHTML={{
              __html: note,
            }}
          />
        </div>
      )}

      <YesNoAsk_Modal
        date={date}
        htmlDivElement={""}
        title={"Submission warning"}
        btnName={"Confirm & Submit"}
        bodyMessage={bodyMessage}
        submitCounter={"2"}
        responseMessage={"Approve"}
        variant={"success"}
        studentId={studentId}
        handleClose={handleClose}
        show={show}
        setShow={setShow}
        reload={reload}
        disabled={isSubmitLoading === true}
        setReload={setReload}
        execFunc={approveRequest}
      />

      {/* Add & Edit Modal  */}
      <Attend_Message_Modal
        newNote={newNote}
        setNewNote={setNewNote}
        title="Leave a note for the student"
        setIsAdd={setIsAdd}
        isOpen={isAdd}
        studentId={studentId}
        disabled={isSubmitLoading === true}
        execFunc={execFunc}
        note={note}
      />
    </>
  );
}

export default AttendShow_Page;
